import { render, staticRenderFns } from "./RoutingRules.vue?vue&type=template&id=2b6518c3"
import script from "./RoutingRules.vue?vue&type=script&lang=js"
export * from "./RoutingRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports